import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { useListExternalIntegrationVendorsQuery } from 'dashboard/redux/api/external-integration-vendor';
import DashboardExternalIntegrationsView from 'dashboard/views/DashboardExternalIntegrationsView';
import useRTKErrorHandler from 'lib/hooks/useRTKErrorHandler';

const DashboardExternalIntegrationsRoute = () => {
  const {
    data: externalIntegrationsVendors = [],
    isLoading: isLoadingVendors,
    error: listIntegrationVendorsError,
  } = useListExternalIntegrationVendorsQuery();

  useRTKErrorHandler({
    error: listIntegrationVendorsError,
    onError: (error) => ({
      message: (error?.errors?.at(0)?.details as string) || error.message,
      level: MessageType.Failure,
    }),
  });

  if (isLoadingVendors) {
    return <LoadingIndicator fullscreen />;
  } else {
    return (
      <DashboardExternalIntegrationsView externalIntegrationVendors={externalIntegrationsVendors} />
    );
  }
};

export default DashboardExternalIntegrationsRoute;
